var SI_SYMBOL = ["", "K", "M", "B", "T", "Q", "QU"];

function convertValue(val) {
    val = val.toString();
    return val.split('.')[0] + (val.split('.').length > 1 ? '.' + val.split('.')[1].substring(0,1) : '');
}

function abbreviateNumber(number){
    if(typeof number === 'number') {
        let thou = Math.pow(10, 3);
        let mil = Math.pow(10, 6);
        let bil = Math.pow(10, 9);
        let tril = Math.pow(10, 12);
        let quad = Math.pow(10, 15);
        let quat = Math.pow(10, 18);

        if (number >= quat) return convertValue(number / quat) + ' Qt';
        else if (number >= quad) return convertValue(number / quad) + ' Q';
        else if (number >= tril) return convertValue(number / tril) + 'T';
        else if (number >= bil) return convertValue(number / bil) + 'B';
        else if (number >= mil) return convertValue(number / mil) + 'M';
        else if (number >= thou) return convertValue(number / thou) + 'k';
        // else if (number >= thou) return Math.round((number / thou) * 100) / 100 + 'k';
        else return number;
    }

    // // what tier? (determines SI symbol)
    // var tier = Math.log10(number) / 3 | 0;

    // // if zero, we don't need a suffix
    // if(tier == 0) return number;

    // // get suffix and determine scale
    // var suffix = SI_SYMBOL[tier];
    // var scale = Math.pow(10, tier * 3);

    // // scale the number
    // var scaled = number / scale;

    // // format number and add suffix
    // console.log("scaled", scaled);
    // console.log("number", number);
    // return scaled.toFixed().split(".0")[0] + suffix;
}

exports.number = abbreviateNumber;
